import moment, {Moment} from 'moment';
import {Data, RecordProps} from '@store/@types/util';

interface CoachingPlanProgressInterface {
  completed: unknown;
  total: unknown;
  projectedEnd: Moment;
}
export default class CoachingPlanProgress extends Data<CoachingPlanProgressInterface>({
  completed: undefined,
  total: undefined,
  projectedEnd: undefined,
}) {
  constructor(obj: RecordProps<CoachingPlanProgressInterface> = {}) {
    super({...obj, projectedEnd: obj.projectedEnd && moment(obj.projectedEnd)});
  }
}
